import Lottie from 'lottie-react';
import React, { useEffect, useRef, useState, } from 'react';
import "./QuestionAnsStyle.css";
import { ToastContainer, toast } from "react-toastify";
import { map } from 'jquery';
import { useDispatch, useSelector } from 'react-redux';
import { fetchUserSubscription } from '../../service/slice/AuthSlice';
import { useReactToPrint } from 'react-to-print';



function QuestionAns() {

    const userDetails = useSelector((state) => state?.userSlice?.value);
    const freeSubscription = useSelector((state) => state?.userSlice?.freeSubscription);
    const unlimited = useSelector((state) => state?.userSlice?.unlimited);
    const userSubscription = useSelector((state) => state?.userSlice?.userSubscription);

    const [searching, setSearching] = useState(false);
    const [searchingText, setSearchingText] = useState(localStorage.getItem('homeSearch') ? localStorage.getItem('homeSearch') : '');
    const usertoken = localStorage.getItem("authToken");
    const [subject, setSubjects] = useState([]);
    const [otherSubject, setOtherSubject] = useState({
        type: "",
        value: ""
    });
    const dispatch = useDispatch()

    const [languages, setLanguages] = useState(
        userDetails?.medium ? JSON.parse(userDetails.medium) : ['English']
    );
    const [selectedLanguage, setSelectedLanguage] = useState(userDetails?.medium ? JSON.parse(userDetails.medium)[0] : 'English');

    function detectRequest() {
        if (userSubscription && userSubscription?.total_request > 0 && userSubscription?.expire_on > Date.now()) {
            return true;
        } else if (freeSubscription > 0) {
            return true;
        } else {
            return false;
        }
    }

    function getFileBase64(file) {
        return new Promise((resolve, reject) => {
            if (file) {
                const reader = new FileReader();

                reader.onloadend = () => {
                    const dataURL = reader.result;
                    // const base64String = dataURL.replace(/^data:.+;base64,/, '');
                    resolve({ dataURL: dataURL, size: file.size, type: file.type });
                };
                reader.readAsDataURL(file);
            } else {
                resolve(undefined)
            }
        })
    }

    async function handleSubmit() {
        const fileInput = document.getElementById('file');
        const file = fileInput.files[0];
        const base64Data = await getFileBase64(file)
        // console.log(base64Data)
        // return;
        if ((searchingText || base64Data) && !searching && otherSubject.value) {
            const detect = detectRequest();
            // console.log(detect)
            if (!detect) {
                document.getElementById('exampleModalBody').innerText = 'You dont have enough request left, Please subscribe to a higher package.'
                document.getElementById('exampleModalBtn').click();
                return;
            }
            if (base64Data && base64Data?.size > 10 * 1024 * 1024) {
                document.getElementById('exampleModalBody').innerText = 'Please select a file less than 10MB'
                document.getElementById('exampleModalBtn').click();
                return;
            }
            setSearching(true)
            document.getElementById('answer').style.display = "none";
            document.getElementById('loading').style.display = "block";
            const responseDiv = document.getElementById('answer');
            responseDiv.innerHTML = '';
            getQuestionResponse(searchingText, base64Data).then((data) => {
                document.getElementById('loading').style.display = "none";
                document.getElementById('answer').style.display = "block";
                setSearching(false)
                if (data.status) {
                    const text = data?.response || "";
                    if (text) {
                        const html = chatGPTResponseToHTML(text);
                        typeHTML(responseDiv, html, 10);
                    } else {
                        document.getElementById('exampleModalBody').innerText = "No data found!"
                        document.getElementById('exampleModalBtn').click()
                    }
                    if (!unlimited) {
                        dispatch(fetchUserSubscription(localStorage.getItem('authToken')))
                    }
                } else {
                    document.getElementById('exampleModalBody').innerText = data.msg
                    document.getElementById('exampleModalBtn').click()
                }
            }).catch((error) => {
                document.getElementById('exampleModalBody').innerText = error.message
                document.getElementById('exampleModalBtn').click()
            })
        } else if (searching) {
            document.getElementById('exampleModalBody').innerText = 'Please wait we are searching your question.'
            document.getElementById('exampleModalBtn').click()
        } else if (!otherSubject.value) {
            document.getElementById('exampleModalBody').innerText = 'Please choose your subject.'
            document.getElementById('exampleModalBtn').click()
        }
        else {
            document.getElementById('exampleModalBody').innerText = 'Please enter something to search.'
            document.getElementById('exampleModalBtn').click()
        }
    }

    function gemeniResponseToHTML(text) {
        if (!text) return "";

        let html = text
            .replace(/&/g, "&amp;")
            .replace(/</g, "&lt;")
            .replace(/>/g, "&gt;")
        // .replaceAll("`", "$$");
        html = html.replace(/\r?\n/g, "<br>");
        html = html.replace(/^(\s*)(-{3,}|\*{3,}|_{3,})(\s*)$/gm, "<hr>");
        html = html.replace(/```([\s\S]*?)```/g, "<pre><code>$1</code></pre>");
        html = html.replace(/`([^`]+)`/g, "<code>$1</code>");
        // html = html.replace(/\*\*(.*?)\*\*/g, "<strong>$1</strong>");
        // html = html.replace(/\$\$(.*?)\$\$/g, "<katex-element>$1</katex-element>");
        // html = html.replace(/\$(.*?)\$/g, "<katex-element>$1</katex-element>");
        html = html.replace(/\$\$(.*?)\$\$/g, '<math-field virtual-keyboard-mode="off" contentEditable="false" readonly="true" enable-menu="false" class="mathRender">$1</math-field>');
        html = html.replace(/\$\$(.*?)\$\$/g, '<math-field virtual-keyboard-mode="off" contentEditable="false" readonly="true" enable-menu="false" class="mathRender">$1</math-field>');
        html = html.replace(/\$(.*?)\$/g, '<math-field virtual-keyboard-mode="off" contentEditable="false" readonly="true" enable-menu="false" class="mathRender">$1</math-field>');
        html = html.replace(/(?<!\*)\*(?!\*)(.*?)\*(?<!\*)/g, "<em>$1</em>");
        html = html.replace(/^### (.*$)/gim, "<h3>$1</h3>");
        html = html.replace(/^## (.*$)/gim, "<h2>$1</h2>");
        html = html.replace(/^# (.*$)/gim, "<h1>$1</h1>");
        html = html.replace(/^> (.*$)/gim, "<blockquote>$1</blockquote>");
        html = html.replace(/^\s*[-*] (.*$)/gim, "<li>$1</li>");
        html = html.replace(/(<li>.*<\/li>\n?)+/gim, match => `<ul>${match}</ul>`);
        html = html.replace(/\n{2,}/g, "</p><p>");
        html = `<div>${html}</div>`;
        html = html.replace(/<p><\/p>/g, "");
        return html.trim();
    }

    function chatGPTResponseToHTML(text) {
        if (!text) return "";

        let html = text;

        // Escape HTML special chars to prevent injection
        html = html.replace(/&/g, "&amp;")
            .replace(/</g, "&lt;")
            .replace(/>/g, "&gt;");

        // Convert horizontal rules (ChatGPT uses --- or *** or ___)
        html = html.replace(/^(\*\*\*|---|___)$/gm, "<hr>");
        html = html.replace(/\$\$(.*?)\$\$/g, '<math-field class="mathfield" virtual-keyboard-mode="off" contentEditable="false" readonly="true" enable-menu="false" class="mathRender">$1</math-field>');
        html = html.replace(/\$(.*?)\$/g, '<math-field class="mathfield" virtual-keyboard-mode="off" contentEditable="false" readonly="true" enable-menu="false" class="mathRender">$1</math-field>');
        // Convert headings (#, ##, ###)
        html = html.replace(/^### (.*$)/gim, "<h3>$1</h3>");
        html = html.replace(/^## (.*$)/gim, "<h2>$1</h2>");
        html = html.replace(/^# (.*$)/gim, "<h1>$1</h1>");

        // Bold and italics (**bold**, *italic*)
        html = html.replace(/\*\*(.*?)\*\*/gim, "<b>$1</b>");
        html = html.replace(/\*(.*?)\*/gim, "<i>$1</i>");

        // Inline code `code`
        html = html.replace(/`([^`]+)`/gim, "<code>$1</code>");

        // Code blocks ```js ... ```
        html = html.replace(/```(\w+)?\n([\s\S]*?)```/gim, (match, lang, code) => {
            return `<pre><code class="language-${lang || ''}">${code.trim()}</code></pre>`;
        });

        // Ordered lists
        html = html.replace(/^\d+\.\s+(.*)$/gim, "<ol><li>$1</li></ol>");
        html = html.replace(/<\/ol>\s*<ol>/gim, ""); // merge consecutive lists

        // Unordered lists
        html = html.replace(/^[*-]\s+(.*)$/gim, "<ul><li>$1</li></ul>");
        html = html.replace(/<\/ul>\s*<ul>/gim, ""); // merge consecutive lists

        // Blockquotes
        html = html.replace(/^>\s+(.*)$/gim, "<blockquote>$1</blockquote>");

        // Newlines to <br> (for paragraph separation)
        html = html.replace(/\n{2,}/g, "</p><p>");
        html = "<p>" + html + "</p>";

        // Clean up multiple <p> or <br> tags
        html = html.replace(/<p><\/p>/g, "");

        return html.trim();
    }

    // ✅ Typing animation for HTML content
    async function typeHTML(element, html, speed = 20) {
        const temp = document.createElement("div");
        temp.innerHTML = html;

        for (let node of temp.childNodes) {
            await typeNode(node, element, speed);
        }
    }

    async function typeNode(node, parent, speed) {
        if (node.nodeType === Node.TEXT_NODE) {
            const text = node.textContent;
            const el = document.createElement('span');
            parent.appendChild(el);
            for (let char of text) {
                el.appendChild(document.createTextNode(char));
                await new Promise(r => setTimeout(r, speed));
            }
        } else if (node.nodeType === Node.ELEMENT_NODE) {
            const el = document.createElement(node.tagName.toLowerCase());
            for (let attr of node.attributes) el.setAttribute(attr.name, attr.value);
            parent.appendChild(el);
            for (let child of node.childNodes) {
                await typeNode(child, el, speed);
            }
        }
    }

    // const API_URL = "https://generativelanguage.googleapis.com/v1beta/models/gemini-2.5-flash:generateContent";

    // async function getGeminiResponse(text) {
    //   try {
    //     const res = await fetch(API_URL, {
    //       method: "POST",
    //       headers: {
    //         "Content-Type": "application/json",
    //         "x-goog-api-key": process.env.REACT_APP_API_KEY
    //       },
    //       body: JSON.stringify({
    //         contents: [
    //           {
    //             parts: [
    //               {
    //                 text: text
    //               }
    //             ]
    //           }
    //         ]
    //       })
    //     });
    //     return res.json();
    //   } catch (err) {
    //     console.error(err);
    //     document.getElementById('exampleModalBody').innerText = err.message
    //     document.getElementById('exampleModalBtn').click()
    //   }
    // }

    async function getQuestionResponse(searchingText, base64Data, type) {
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/service/getAnswer`, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": `Bearer ${usertoken}`
                },
                method: "POST",
                body: JSON.stringify({
                    question: searchingText,
                    type: !base64Data ? 'Question' : (base64Data?.type == "application/pdf" || base64Data?.type == "application/msword") ? 'File' : 'Image',
                    file: base64Data && base64Data?.dataURL,
                    subject: otherSubject.value,
                    medium: selectedLanguage
                })
            })
            return response.json()
        } catch (error) {
            return { status: false, error: error.message }
        }
    }


    // Fetch All Study Profile
    const fetchSubjects = async () => {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/service/getAllSubject`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${usertoken}`
            },
        });
        return response.json();
    };

    const componentRef = useRef(null);

    const handlePrint = useReactToPrint({ componentRef });

    useEffect(() => {
        const searchText = localStorage.getItem('homeSearch')
        const searchFile = localStorage.getItem('homeFile');
        if (!searchText && !searchFile) {
            return;
        }
        setSearchingText(searchText)
        getFileBase64(JSON.parse(searchFile)).then((base64Data) => {
            if ((searchText || base64Data) && !searching && otherSubject.value) {
                const detect = detectRequest();
                if (!detect) {
                    document.getElementById('exampleModalBody').innerText = 'You dont have enough request left, Please subscribe to a higher package.'
                    document.getElementById('exampleModalBtn').click();
                    return;
                }
                if (base64Data && base64Data?.size > 10 * 1024 * 1024) {
                    document.getElementById('exampleModalBody').innerText = 'Please select a file less than 10MB'
                    document.getElementById('exampleModalBtn').click();
                    return;
                }
                setSearching(true)
                document.getElementById('answer').style.display = "none";
                document.getElementById('loading').style.display = "block";
                const responseDiv = document.getElementById('answer');
                responseDiv.innerHTML = '';
                getQuestionResponse(searchText, base64Data).then((data) => {
                    document.getElementById('loading').style.display = "none";
                    document.getElementById('answer').style.display = "block";
                    setSearching(false)
                    if (data.status) {
                        const text = data?.response || "";
                        if (text) {
                            const html = chatGPTResponseToHTML(text);
                            typeHTML(responseDiv, html, 10);
                        } else {
                            document.getElementById('exampleModalBody').innerText = "No data found!"
                            document.getElementById('exampleModalBtn').click()
                        }
                        if (!unlimited) {
                            dispatch(fetchUserSubscription(localStorage.getItem('authToken')))
                        }
                    } else {
                        document.getElementById('exampleModalBody').innerText = data.msg
                        document.getElementById('exampleModalBtn').click()
                    }
                }).catch((error) => {
                    document.getElementById('exampleModalBody').innerText = error.message
                    document.getElementById('exampleModalBtn').click()
                })
            } else if (searching) {
                document.getElementById('exampleModalBody').innerText = 'Please wait we are searching your question.'
                document.getElementById('exampleModalBtn').click()
            } else if (!otherSubject.value) {
                document.getElementById('exampleModalBody').innerText = 'Please choose your subject.'
                document.getElementById('exampleModalBtn').click()
            }
            else {
                document.getElementById('exampleModalBody').innerText = 'Please enter something to search.'
                document.getElementById('exampleModalBtn').click()
            }
            localStorage.removeItem('homeSearch')
            localStorage.removeItem('homeFile')
        })
    }, [])


    useEffect(() => {
        const file = document.getElementById('file');
        const dropzone = document.getElementById('dropzone');
        const fileList = document.getElementById('fileList');
        const fileHint = document.getElementById('fileHint');
        // const copyBtn = document.getElementById('copy');
        const printBtn = document.getElementById('print');
        const answer = document.getElementById('answer');

        function renderFiles(files) {
            fileList.innerHTML = '';
            if (!files || !files.length) { fileHint.textContent = 'No file chosen'; return; }
            fileHint.textContent = files.length + (files.length === 1 ? ' file selected' : ' files selected');
            [...files].forEach(f => {
                const li = document.createElement('div');
                li.textContent = `${f.name} • ${Math.round(f.size / 1024)}KB`;
                fileList.appendChild(li);
            });
        }

        file.addEventListener('change', e => renderFiles(e.target.files));

        // Drag & Drop on dropzone
        ;['dragenter', 'dragover'].forEach(evt => dropzone.addEventListener(evt, e => { e.preventDefault(); dropzone.style.background = '#fff'; }));
        ;['dragleave', 'drop'].forEach(evt => dropzone.addEventListener(evt, e => { e.preventDefault(); dropzone.style.background = 'var(--soft)'; }));
        dropzone.addEventListener('drop', e => { const files = e.dataTransfer?.files; if (files) { file.files = files; renderFiles(files); } });

        // Paste image
        document.addEventListener('paste', e => {
            const items = e.clipboardData?.items || []; const files = [];
            for (const it of items) { if (it.kind === 'file') { files.push(it.getAsFile()); } }
            if (files.length) { const dt = new DataTransfer(); files.forEach(f => dt.items.add(f)); file.files = dt.files; renderFiles(file.files); }
        });

        // copyBtn.addEventListener('click', () => {
        //     const tmp = document.createElement('textarea');
        //     tmp.value = answer.innerText || '';
        //     document.body.appendChild(tmp); tmp.select(); document.execCommand('copy'); document.body.removeChild(tmp);
        //     copyBtn.textContent = 'Copied'; setTimeout(() => copyBtn.textContent = 'Copy', 800);
        // });
        printBtn.addEventListener('click', () => {
            // document.getElementsByClassName('left-side-bar')[0].classList.add("d-none")
            // window.print();
            // document.getElementsByClassName('left-side-bar')[0].classList.remove("d-none")
            printDiv('answer')

        });


        fetchSubjects().then((res) => {
            if (res.status) {
                setSubjects(res?.subjects)
            } else {
                toast.error("Failed to load subject. Please try again.");
            }
        }).catch((error) => {
            toast.error("Unable to fetch subject at the moment.");
        });

    }, [])

    function printDiv(divId) {
        // Get the element
        const divToPrint = document.getElementById(divId);

        if (!divToPrint) {
            console.error('Div not found:', divId);
            return;
        }

        // Create a new window for printing
        const printWindow = window.open('', '_blank', 'width=800,height=600');

        // Write the div content and basic styles
        printWindow.document.write(`
    <html>
      <head>
        <title>Print Preview</title>
        <style>
          body {
            font-family: Arial, sans-serif;
            margin: 20px;
          }
          .content {
            max-height: none;
            overflow: visible;
          }
        </style>
      </head>
      <body>
        <div class="content">
          ${divToPrint.innerHTML}
        </div>
        <script>
          window.onload = function() {
            window.print();
            window.onafterprint = function() { window.close(); };
          };
        <\/script>
      </body>
    </html>
  `);

        printWindow.document.close();
    }


    return (
        <div className="wrap" >
            {/* <h1>Question (type or paste)</h1> */}
            <div className="card" style={{ padding: "16px" }}>
                <div Style="border-bottom: 1px solid #e5e4ff; margin-bottom: 20px;">
                    {unlimited ?
                        <h3 Style="display: flex;  align-items: center;">Unlimited</h3>
                        :
                        <h3 Style="display: flex;  align-items: center;">Your request left <span Style="font-size: 49px; color: #3f3eed; margin-left: 10px; font-weight: 700;">{userSubscription && userSubscription?.expire_on > Date.now() ? userSubscription?.total_request : freeSubscription}</span></h3>
                    }
                </div>
                <div className='d-flex justify-content-between'>
                    <p className='h5'>Enter your question</p>
                    <div className="col-4 col-md-4">
                        <div className="input-wrapper">
                            <select value={selectedLanguage} onChange={(event) => setSelectedLanguage(event.target.value)} required >
                                {languages.map((lang, i) => (
                                    <option key={i} value={lang}>
                                        {lang}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>
                </div>

                {/* <label for="q">Enter your question</label> */}
                <textarea id="q" placeholder="e.g., Solve: If sin²x + cos²x = 1, find d/dx[sin²x] for x ∈ ℝ." onChange={(event) => { setSearchingText(event.target.value) }}>{searchingText}</textarea>

                <div className="" Style="margin-top:10px">
                    <div className="dropzone" id="dropzone" onClick={() => { document.getElementById("file").click() }}>
                        <Lottie animationData={require("../../screenassets/lottiefiles/UploadFiles.json")} loop={true} style={{ height: "150px" }} />
                        <input id="file" type="file" accept="image/*,application/pdf, application/doc" multiple />
                        <div className="dz-title">Drop images/PDF here or click to upload</div>
                        <div className="dz-sub" id="fileHint">No file chosen</div>
                        <div className="filelist" id="fileList" aria-live="polite"></div>
                    </div>
                    <div>
                        {/* <div className="actions" Style="justify-content:flex-start">
                            <button className="btn primary" id="solve" onClick={handleSubmit}>Get Answer</button>
                            <button className="btn" id="clear" type="button">Clear</button>
                        </div> */}

                        <div class="row">
                            <div className='col-md-12 d-flex justify-content-start mt-6 gap-2'>
                                <div class="input-wrapper col-md-6">
                                    <select value={otherSubject.value} onChange={(event) => { setOtherSubject({ value: event.target.value == "Others" ? "" : event.target.value, type: event.target.value }); }} required>
                                        <option value="">Select Subject</option>
                                        {subject.map((sub, idx) => {
                                            return <option key={idx} value={sub.subject}>{sub.subject}</option>
                                        })
                                        }
                                        <option value="Others">Others Subject</option>
                                    </select>
                                </div>

                                {otherSubject.type === "Others" && <div className="input-wrapper col-md-6">
                                    <input type="text" value={otherSubject.value} onChange={(event) => { setOtherSubject({ ...otherSubject, value: event.target.value }) }} placeholder="Subject Name" Style="border:none !important" required />
                                </div>}
                            </div>
                        </div>

                        <div class="row mt-5">
                            <div className='col-md-12 d-flex justify-content-start mt-2 gap-2'>
                                <button class="btn primary col-md-6" id="solve" onClick={handleSubmit}>Get Answer</button>
                                <button class="btn col-md-6" id="clear" type="button">Clear</button>
                            </div>
                        </div>

                        {/* <div className="tip">Tip: You can also paste an image (Ctrl/Cmd + V) directly into the page.</div> */}
                    </div>
                </div>

                <div className="result">
                    <div className="result-head">
                        <div className="result-title">Answer</div>
                        <div className="result-tools">
                            {/* <button className="btn button-flex d-flex">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><path d="M288 64C252.7 64 224 92.7 224 128L224 384C224 419.3 252.7 448 288 448L480 448C515.3 448 544 419.3 544 384L544 183.4C544 166 536.9 149.3 524.3 137.2L466.6 81.8C454.7 70.4 438.8 64 422.3 64L288 64zM160 192C124.7 192 96 220.7 96 256L96 512C96 547.3 124.7 576 160 576L352 576C387.3 576 416 547.3 416 512L416 496L352 496L352 512L160 512L160 256L176 256L176 192L160 192z" /></svg>
                                <span id="copy"> Copy</span>
                            </button> */}
                            <button className="btn button-flex d-flex" >
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><path d="M128 128C128 92.7 156.7 64 192 64L405.5 64C422.5 64 438.8 70.7 450.8 82.7L493.3 125.2C505.3 137.2 512 153.5 512 170.5L512 208L128 208L128 128zM64 320C64 284.7 92.7 256 128 256L512 256C547.3 256 576 284.7 576 320L576 416C576 433.7 561.7 448 544 448L512 448L512 512C512 547.3 483.3 576 448 576L192 576C156.7 576 128 547.3 128 512L128 448L96 448C78.3 448 64 433.7 64 416L64 320zM192 480L192 512L448 512L448 416L192 416L192 480zM520 336C520 322.7 509.3 312 496 312C482.7 312 472 322.7 472 336C472 349.3 482.7 360 496 360C509.3 360 520 349.3 520 336z" /></svg>
                                <span id="print"> Print</span>
                            </button>
                        </div>
                    </div>
                    <div className="result-body" id="result" aria-live="polite" ref={componentRef}>
                        <p Style="color: #b2b0b0 !important">Your answer will display here.</p>
                        <div id="loading" Style="display:none">
                            <div className="skeleton" Style="width:70%"></div>
                            <div className="sk-gap"></div>
                            <div className="skeleton" Style="width:95%"></div>
                            <div className="sk-gap"></div>
                            <div className="skeleton" Style="width:60%"></div>
                            <div className="sk-gap"></div>
                            <div className="skeleton" Style="width:85%"></div>
                        </div>

                        <div id="answer" Style="display:none">
                            {/* <div className="step"><strong>Step 1 (Chain rule):</strong> Let u = sin x. Then sin²x = u², so d/dx(u²) = 2u·du/dx.</div>
              <div className="step"><strong>Step 2:</strong> du/dx = cos x.</div>
              <div className="step"><strong>Answer:</strong> d/dx[sin²x] = 2 sin x cos x = sin(2x).</div> */}
                        </div>
                    </div>
                </div>
            </div>

            <button type="button" class="btn btn-primary d-none" id='exampleModalBtn' data-bs-toggle="modal" data-bs-target="#staticBackdrop">
                Launch static backdrop modal
            </button>

            <div class="modal fade" id="staticBackdrop" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered">
                    <div class="modal-content">
                        <div class="modal-header" style={{ marginBottom: "12px", padding: "0px" }}>
                            <h3 class="modal-title text-danger" id="staticBackdropLabel" >Error</h3>
                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div class="modal-body">
                            <Lottie animationData={require("../../screenassets/lottiefiles/warning.json")} loop={true} style={{ height: "150px" }} />
                            <h4 id='exampleModalBody' className='text-dark text-center'></h4>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default QuestionAns